
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from '../../../config.js';

export const useUploadReceiptMutation = ({setsnackbarStatus, setUploadProgress}) => {

    const queryClient = useQueryClient();



    return useMutation({
        mutationFn: ({ formData, selectedhospCaseHospID, selectedhospCaseUserID }) => {


            return axios.post(
                `${config.API_URL}/payment/pushBlob?selectedhospCaseHospID=${selectedhospCaseHospID}&selectedhospCaseUserID=${selectedhospCaseUserID}`,
                formData,
                {
                    withCredentials: true,
                    onUploadProgress: progressEvent => setUploadProgress(Math.round((progressEvent.loaded / progressEvent.total) * 100))
                }

            );
        },
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({ queryKey: ['ActivePaymentList'], refetchType: 'active'}, {cancelRefetch: false });
            queryClient.invalidateQueries({ queryKey: ['ActivePaymentListGroup'], refetchType: 'active'}, {cancelRefetch: false });
            queryClient.invalidateQueries({ queryKey: ['ActivePaymentListAggr'], refetchType: 'active'}, {cancelRefetch: false});


        },
        onError: (error, variables) => {

            setsnackbarStatus(
                {
                    open: true,
                    message: `Error Uploading File`,
                    severity: 'error'

                }
            )
        },

    })






}